function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { sortItems } from "./helpers";
/**
 * Columns API
 * @param {Object} instance DataTable instance
 * @param {Mixed} columns  Column index or array of column indexes
 */

export var Columns = /*#__PURE__*/function () {
  function Columns(dt) {
    _classCallCheck(this, Columns);

    this.dt = dt;
    return this;
  }
  /**
   * Swap two columns
   * @return {Void}
   */


  _createClass(Columns, [{
    key: "swap",
    value: function swap(columns) {
      if (columns.length && columns.length === 2) {
        var cols = []; // Get the current column indexes

        this.dt.headings.forEach(function (h, i) {
          cols.push(i);
        });
        var x = columns[0];
        var y = columns[1];
        var b = cols[y];
        cols[y] = cols[x];
        cols[x] = b;
        this.order(cols);
      }
    }
    /**
     * Reorder the columns
     * @return {Array} columns  Array of ordered column indexes
     */

  }, {
    key: "order",
    value: function order(columns) {
      var a;
      var b;
      var c;
      var d;
      var h;
      var s;
      var cell;
      var temp = [[], [], [], []];
      var dt = this.dt; // Order the headings

      columns.forEach(function (column, x) {
        h = dt.headings[column];
        s = h.getAttribute("data-sortable") !== "false";
        a = h.cloneNode(true);
        a.originalCellIndex = x;
        a.sortable = s;
        temp[0].push(a);

        if (!dt.hiddenColumns.includes(column)) {
          b = h.cloneNode(true);
          b.originalCellIndex = x;
          b.sortable = s;
          temp[1].push(b);
        }
      }); // Order the row cells

      dt.data.forEach(function (row, i) {
        c = row.cloneNode(false);
        d = row.cloneNode(false);
        c.dataIndex = d.dataIndex = i;

        if (row.searchIndex !== null && row.searchIndex !== undefined) {
          c.searchIndex = d.searchIndex = row.searchIndex;
        } // Append the cell to the fragment in the correct order


        columns.forEach(function (column) {
          cell = row.cells[column].cloneNode(true);
          cell.data = row.cells[column].data;
          c.appendChild(cell);

          if (!dt.hiddenColumns.includes(column)) {
            cell = row.cells[column].cloneNode(true);
            cell.data = row.cells[column].data;
            d.appendChild(cell);
          }
        });
        temp[2].push(c);
        temp[3].push(d);
      });
      dt.headings = temp[0];
      dt.activeHeadings = temp[1];
      dt.data = temp[2];
      dt.activeRows = temp[3]; // Update

      dt.update();
    }
    /**
     * Hide columns
     * @return {Void}
     */

  }, {
    key: "hide",
    value: function hide(columns) {
      if (columns.length) {
        var dt = this.dt;
        columns.forEach(function (column) {
          if (!dt.hiddenColumns.includes(column)) {
            dt.hiddenColumns.push(column);
          }
        });
        this.rebuild();
      }
    }
    /**
     * Show columns
     * @return {Void}
     */

  }, {
    key: "show",
    value: function show(columns) {
      if (columns.length) {
        var index;
        var dt = this.dt;
        columns.forEach(function (column) {
          index = dt.hiddenColumns.indexOf(column);

          if (index > -1) {
            dt.hiddenColumns.splice(index, 1);
          }
        });
        this.rebuild();
      }
    }
    /**
     * Check column(s) visibility
     * @return {Boolean}
     */

  }, {
    key: "visible",
    value: function visible(columns) {
      var cols;
      var dt = this.dt;
      columns = columns || dt.headings.map(function (th) {
        return th.originalCellIndex;
      });

      if (!isNaN(columns)) {
        cols = !dt.hiddenColumns.includes(columns);
      } else if (Array.isArray(columns)) {
        cols = [];
        columns.forEach(function (column) {
          cols.push(!dt.hiddenColumns.includes(column));
        });
      }

      return cols;
    }
    /**
     * Add a new column
     * @param {Object} data
     */

  }, {
    key: "add",
    value: function add(data) {
      var _this = this;

      var td;
      var th = document.createElement("th");

      if (!this.dt.headings.length) {
        this.dt.insert({
          headings: [data.heading],
          data: data.data.map(function (i) {
            return [i];
          })
        });
        this.rebuild();
        return;
      }

      if (!this.dt.hiddenHeader) {
        if (data.heading.nodeName) {
          th.appendChild(data.heading);
        } else {
          th.innerHTML = data.heading;
        }
      } else {
        th.innerHTML = "";
      }

      this.dt.headings.push(th);
      this.dt.data.forEach(function (row, i) {
        if (data.data[i]) {
          td = document.createElement("td");

          if (data.data[i].nodeName) {
            td.appendChild(data.data[i]);
          } else {
            td.innerHTML = data.data[i];
          }

          td.data = td.innerHTML;

          if (data.render) {
            td.innerHTML = data.render.call(_this, td.data, td, row);
          }

          row.appendChild(td);
        }
      });

      if (data.type) {
        th.setAttribute("data-type", data.type);
      }

      if (data.format) {
        th.setAttribute("data-format", data.format);
      }

      if (data.hasOwnProperty("sortable")) {
        th.sortable = data.sortable;
        th.setAttribute("data-sortable", data.sortable === true ? "true" : "false");
      }

      this.rebuild();
      this.dt.renderHeader();
    }
    /**
     * Remove column(s)
     * @param  {Array|Number} select
     * @return {Void}
     */

  }, {
    key: "remove",
    value: function remove(select) {
      var _this2 = this;

      if (Array.isArray(select)) {
        // Remove in reverse otherwise the indexes will be incorrect
        select.sort(function (a, b) {
          return b - a;
        });
        select.forEach(function (column) {
          return _this2.remove(column);
        });
      } else {
        this.dt.headings.splice(select, 1);
        this.dt.data.forEach(function (row) {
          row.removeChild(row.cells[select]);
        });
      }

      this.rebuild();
    }
    /**
     * Filter by column
     * @param  {int} column - The column no.
     * @param  {string} dir - asc or desc
     * @filter {array} filter - optional parameter with a list of strings
     * @return {void}
     */

  }, {
    key: "filter",
    value: function filter(column, dir, init, terms) {
      var dt = this.dt; // Creates a internal state that manages filters if there are none

      if (!dt.filterState) {
        dt.filterState = {
          originalData: dt.data
        };
      } // If that column is was not filtered yet, we need to create its state


      if (!dt.filterState[column]) {
        // append a filter that selects all rows, 'resetting' the filter
        var filters = [].concat(_toConsumableArray(terms), [function () {
          return true;
        }]);

        dt.filterState[column] = function () {
          var i = 0;
          return function () {
            return filters[i++ % filters.length];
          };
        }();
      } // Apply the filter and rebuild table


      var rowFilter = dt.filterState[column](); // fetches next filter

      var filteredRows = Array.from(dt.filterState.originalData).filter(function (tr) {
        var cell = tr.cells[column];
        var content = cell.hasAttribute("data-content") ? cell.getAttribute("data-content") : cell.innerText; // If the filter is a function, call it, if it is a string, compare it

        return typeof rowFilter === "function" ? rowFilter(content) : content === rowFilter;
      });
      dt.data = filteredRows;

      if (!dt.data.length) {
        dt.clear();
        dt.hasRows = false;
        dt.setMessage(dt.options.labels.noRows);
      } else {
        this.rebuild();
        dt.update();
      }

      if (!init) {
        dt.emit("datatable.sort", column, dir);
      }
    }
    /**
     * Sort by column
     * @param  {int} column - The column no.
     * @param  {string} dir - asc or desc
     * @return {void}
     */

  }, {
    key: "sort",
    value: function sort(column, dir, init) {
      var _this3 = this;

      var dt = this.dt; // Check column is present

      if (dt.hasHeadings && (column < 0 || column > dt.headings.length)) {
        return false;
      } //If there is a filter for this column, apply it instead of sorting


      var filterTerms = dt.options.filters && dt.options.filters[dt.headings[column].textContent];

      if (filterTerms && filterTerms.length !== 0) {
        this.filter(column, dir, init, filterTerms);
        return;
      }

      dt.sorting = true;

      if (!init) {
        dt.emit("datatable.sorting", column, dir);
      }

      var rows = dt.data;
      var alpha = [];
      var numeric = [];
      var a = 0;
      var n = 0;
      var th = dt.headings[column];
      var waitFor = []; // Check for date format

      if (th.getAttribute("data-type") === "date") {
        var format = false;
        var formatted = th.hasAttribute("data-format");

        if (formatted) {
          format = th.getAttribute("data-format");
        }

        waitFor.push(import("./date").then(function (_ref) {
          var parseDate = _ref.parseDate;
          return function (date) {
            return parseDate(date, format);
          };
        }));
      }

      Promise.all(waitFor).then(function (importedFunctions) {
        var parseFunction = importedFunctions[0]; // only defined if date

        Array.from(rows).forEach(function (tr) {
          var cell = tr.cells[column];
          var content = cell.hasAttribute("data-content") ? cell.getAttribute("data-content") : cell.innerText;
          var num;

          if (parseFunction) {
            num = parseFunction(content);
          } else if (typeof content === "string") {
            num = content.replace(/(\$|,|\s|%)/g, "");
          } else {
            num = content;
          }

          if (parseFloat(num) == num) {
            numeric[n++] = {
              value: Number(num),
              row: tr
            };
          } else {
            alpha[a++] = {
              value: typeof content === "string" ? content.toLowerCase() : content,
              row: tr
            };
          }
        });
        /* Sort according to direction (ascending or descending) */

        if (!dir) {
          if (th.classList.contains("asc")) {
            dir = "desc";
          } else {
            dir = "asc";
          }
        }

        var top;
        var btm;

        if (dir == "desc") {
          top = sortItems(alpha, -1);
          btm = sortItems(numeric, -1);
          th.classList.remove("asc");
          th.classList.add("desc");
        } else {
          top = sortItems(numeric, 1);
          btm = sortItems(alpha, 1);
          th.classList.remove("desc");
          th.classList.add("asc");
        }
        /* Clear asc/desc class names from the last sorted column's th if it isn't the same as the one that was just clicked */


        if (dt.lastTh && th != dt.lastTh) {
          dt.lastTh.classList.remove("desc");
          dt.lastTh.classList.remove("asc");
        }

        dt.lastTh = th;
        /* Reorder the table */

        rows = top.concat(btm);
        dt.data = [];
        var indexes = [];
        rows.forEach(function (v, i) {
          dt.data.push(v.row);

          if (v.row.searchIndex !== null && v.row.searchIndex !== undefined) {
            indexes.push(i);
          }
        });
        dt.searchData = indexes;

        _this3.rebuild();

        dt.update();

        if (!init) {
          dt.emit("datatable.sort", column, dir);
        }
      });
    }
    /**
     * Rebuild the columns
     * @return {Void}
     */

  }, {
    key: "rebuild",
    value: function rebuild() {
      var a;
      var b;
      var c;
      var d;
      var dt = this.dt;
      var temp = [];
      dt.activeRows = [];
      dt.activeHeadings = [];
      dt.headings.forEach(function (th, i) {
        th.originalCellIndex = i;
        th.sortable = th.getAttribute("data-sortable") !== "false";

        if (!dt.hiddenColumns.includes(i)) {
          dt.activeHeadings.push(th);
        }
      }); // Loop over the rows and reorder the cells

      dt.data.forEach(function (row, i) {
        a = row.cloneNode(false);
        b = row.cloneNode(false);
        a.dataIndex = b.dataIndex = i;

        if (row.searchIndex !== null && row.searchIndex !== undefined) {
          a.searchIndex = b.searchIndex = row.searchIndex;
        } // Append the cell to the fragment in the correct order


        Array.from(row.cells).forEach(function (cell) {
          c = cell.cloneNode(true);
          c.data = cell.data;
          a.appendChild(c);

          if (!dt.hiddenColumns.includes(c.cellIndex)) {
            d = c.cloneNode(true);
            d.data = c.data;
            b.appendChild(d);
          }
        }); // Append the fragment with the ordered cells

        temp.push(a);
        dt.activeRows.push(b);
      });
      dt.data = temp;
      dt.update();
    }
  }]);

  return Columns;
}();